import styled, { css } from 'styled-components';
import { mediaMd, mediaSm, mediaXs } from 'theme/theme-helper-selectors';

export const Container = styled.div<{ secondary?: boolean }>`
    position: relative;
    padding: 90px 0 80px;

    @media (${mediaMd}) {
        padding: 90px 0 0;
    }

    ${({ secondary }) =>
        secondary &&
        css`
            ${Title} {
                display: none;
            }

            ${TextContainer} {
                justify-content: flex-end;
            }

            @media (${mediaSm}) {
                padding: 380px 0 45px;
            }
        `};
`;

export const Bubble7 = styled.img`
    position: absolute;
    left: -5%;
    top: -80px;

    @media (${mediaSm}) {
        top: -70px;
        width: 100px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

export const Bubble8 = styled.img`
    position: absolute;
    right: 0;
    top: 230px;

    @media (${mediaSm}) {
        width: 150px;
        top: auto;
        bottom: 150px;
    }
`;

const TitleMixin = css`
    font-size: 72px;
    line-height: 72px;
    font-weight: 500;

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 36px;
    }
`;

export const Title = styled.h3`
    ${TitleMixin}
    position: absolute;
    width: 400px;
    left: 0;
    bottom: 20px;

    @media (${mediaSm}) {
        top: 0;
        left: 0;
    }
`;

export const TextContainer = styled.div`
    padding-left: 250px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 32px;
    position: relative;
    z-index: 15;

    @media (${mediaSm}) {
        flex-direction: column;
        align-items: flex-start;
        padding: 45px 0 0 0;
    }

    @media (${mediaXs}) {
        gap: 15px;
    }
`;

export const DescriptionContainer = styled.div`
    width: 60%;

    @media (${mediaSm}) {
        width: 100%;
    }
`;

export const Description = styled.div<{ secondary?: boolean }>`
    font-size: 32px;
    line-height: 36px;
    font-weight: 500;
    margin: 0 0 60px 0;
    padding-left: 170px;

    @media (${mediaSm}) {
        font-size: 21px;
        line-height: 24px;
        margin: 0 0 40px 0;
        max-width: initial;
        padding: 0;
    }
`;
